import type { SWRConfiguration } from "swr";

export const ONE_MINUTE = /*ms*/ 1000 * /*s*/ 60 * /*min*/ 1;

export function createSwrConfiguration(options?: SWRConfiguration): SWRConfiguration {
  return {
    dedupingInterval: ONE_MINUTE * 5,
    revalidateOnFocus: false,
    revalidateOnMount: true,
    errorRetryCount: 3,
    ...options,
  };
}
